<template>
  <div class="overflow border border-1 rounded">
    <table class="w-100">
      <slot />
    </table>
  </div>
</template>

<style scoped lang="scss">
@import "@/designSystem/Table/cx-table.scss";
</style>
